<template>
    <div ref="outerElementRef" class="settings-page__software-license">
        <software-license ref="softwareLicense" @ready="onReadeSoftwareLicense" @start="onStartSoftwareLicense" />
    </div>
</template>

<script setup lang="ts">
    const emit = defineEmits(['data-loading']);

    const onStartSoftwareLicense = (): void => {
        emit("data-loading", true);
    };
    const onReadeSoftwareLicense = (): void  => {
        emit("data-loading", false);
    };
</script>